/*
Styled chip to display status.

Props (*required):
	*value	- string; text to display
	color	- string; color of the chip/text

Usage:
	<StatusChip value="" color=""/>
*/

export default function StatusChip(props) {
	let chipColor;
	let textColor;

	switch (props.color) {
		case "green":
			chipColor = "#C6D9BA";
			textColor = "#114503";
			break;
		case "yellow":
			chipColor = "#FFE9AB";
			textColor = "#614700";
			break;
		case "orange":
			chipColor = "#FCD7BD";
			textColor = "#6E350C";
			break;
		case "red":
			chipColor = "#FCBDBD";
			textColor = "#6E0C0C";
			break;
		default:	// Grey is default
			chipColor = "#EBEBEB";
			textColor = "#4F4F4F";
			break;
	}

	const chipStyle = {
		width: "fit-content",
		padding: "4px 8px",
		borderRadius: "32px",
		background: chipColor,
	}

	const textStyle = {
		margin: 0,
		fontSize: "14px",
		color: textColor,
	}


	return (
		props.value
			? (
				<div style={chipStyle}>
					<p style={textStyle}>
						{props.value}
					</p>
				</div>
			)
			: <></>
	)
}